module.exports = __webpack_public_path__ + "static/media/joyable7.9d71e4cb.jpg";